const adjustFontSize = () => {
  const $headlines = $('.title-container h1');

  if ($headlines.length <= 0) return null;

  const adjustSize = ($element) => {
      const maxWidth = $element.width();
      while ($element[0].scrollWidth > maxWidth) {
          const newFontSize = parseInt($element.css('font-size')) - 1;
          if (newFontSize < 10) {
              break;
          }
          $element.css('font-size', newFontSize + 'px');
      }
  };

  $headlines.each(function() {
      adjustSize($(this));
  });

  $(window).resize(function() {
      $headlines.each(function() {
          $(this).css('font-size', ''); // Reset to default size before adjusting
          adjustSize($(this));
      });
  });
};

export default adjustFontSize;